import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledContainer = styled(Box)(({ theme }) => ({
  minHeight: "100vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "#f5f5f5",
}));

export const HeaderLogoImage = styled("img")(() => ({
  width: 200,
  height: "auto",
}));

export const StyledLogoContainer = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  mb: 3,
}));
